import { defaultHttpClient } from '../../httpClient';
import type { GoodsReviewSummaryResponse } from './types';

export const getGoodsReviewSummary = (sno: number) => {
  return defaultHttpClient
    .request<GoodsReviewSummaryResponse>({
      method: 'GET',
      url: `/api/v2/goods/${sno}/review_summary/`,
    })
    .then(result => result.data);
};
